import { makeStyles } from "@mui/styles";
import {
  SURVEY_SPACING,
  SURVEY_MIXINS,
  SURVEY_COLORS,
  SURVEY_TYPOGRAPHY,
} from "../../shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
export const useBooleanQuestionStyles = makeStyles(() => ({
  container: {
    marginTop: SURVEY_SPACING.QUESTION_MARGIN_TOP,
  },
  formLabel: {
    paddingBottom: SURVEY_SPACING.LABEL_PADDING_BOTTOM,
  },
  hint: {
    fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_HINT,
    lineHeight: SURVEY_TYPOGRAPHY.LINE_HEIGHT_COMPACT,
    color: SURVEY_COLORS.TEXT_SECONDARY,
    marginTop: "4px",
  },
  questionText: SURVEY_MIXINS.questionLabel,
  requiredAsterisk: SURVEY_MIXINS.requiredAsterisk,
  optionButtons: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    alignItems: "stretch",
    width: "100%",
    gap: 15,
    flexWrap: "nowrap",
  },
  optionControl: {
    flex: 1,
    margin: "0 !important",
    border: `1px solid ${SURVEY_COLORS.BUTTON_PRIMARY}`,
    borderRadius: 6,
    minHeight: 34,
    minWidth: 60,
    cursor: "pointer",
    backgroundColor: SURVEY_COLORS.WHITE,
    color: SURVEY_COLORS.BUTTON_PRIMARY,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: SURVEY_COLORS.WHITE,
    },
    "& .MuiFormControlLabel-label": {
      width: "100%",
    },
  },
  leftOption: {
    borderRadius: 6,
  },
  rightOption: {
    borderRadius: 6,
  },
  optionControlSelected: {
    backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
    borderColor: SURVEY_COLORS.BUTTON_PRIMARY,
    color: SURVEY_COLORS.WHITE,
    "& $optionLabel": {
      color: `${SURVEY_COLORS.WHITE} !important`,
    },
    "&:hover": {
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
    },
  },
  hiddenRadio: {
    width: 1,
    height: 1,
    margin: 0,
    opacity: 0,
    overflow: "hidden",
    position: "absolute",
    pointerEvents: "none",
  },
  optionLabel: {
    ...SURVEY_MIXINS.optionLabel,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
    margin: 0,
    fontSize: "13px",
    lineHeight: "18px",
  },
  radioGroupError: SURVEY_MIXINS.errorBorder,
  errorBorder: SURVEY_MIXINS.errorBorder,
}));
